(function () {

    'use strict';

    angular
        .module('AutoPrequal')
        .directive('modalTrigger', ['$rootScope', '$compile', function ($rootScope, $compile) {
            return {
                restrict: 'A',
                link: function (scope, element, attrs, ngModel) {

                    var el = angular.element('<span class= "offscreen"> {{glContent.open_modal_window}}</span>');

                    $compile(el)(scope);
                    element.append(el);

                    element.bind('click', function (event) {
                        var reviewTerms = $(element[0]).children(".review-terms");
                        if (reviewTerms[0]) {
                            $rootScope.modalTrigger = reviewTerms[0];
                        } else {
                            $rootScope.modalTrigger = $(element[0]);
                        }
                    });

                    element.bind("keydown keypress", function (event) {
                        if (event.which === 13) {
                            $rootScope.modalTrigger = $(element[0]);
                            event.preventDefault();
                        }
                    });
                }
            }
        }]);

})();
